import { BaseEntity } from '@/remoteApi/EntityApi';
import { RemoteUser } from '@/remoteApi/UserApi';
import { QueryKey } from '@/configs/queryKeys';
import httpClient from '@/remoteApi/httpClient';
import { QueryFunctionContext } from '@tanstack/react-query';
import { UUID } from 'crypto';
import { ShippingMethod } from '@/remoteApi/ShippingMethodApi';
import { Project } from '@/remoteApi/ProjectsApi';

export interface Cart extends BaseEntity {
	user: RemoteUser;
	items: CartItem[];
	totalPrice: number;
	totalGrossPrice: number;
	shippingMethod: ShippingMethod | null;
}

export interface CartItem {
	id: string;
	project: Project;
	quantity: number;
}

interface AddToCartDto {
	project: {
		id: UUID;
	};
	quantity: number;
}

class CartApi {
	queryKey = QueryKey.carts;

	async getUserCart({ queryKey }: QueryFunctionContext<[QueryKey]>) {
		const response = await httpClient.get<Cart>(`${queryKey[0]}`);

		return response.data;
	}

	async addToCart(payload: AddToCartDto) {
		const response = await httpClient.post<Cart>(
			`${QueryKey.carts}/items`,
			payload
		);
		return response.data;
	}

	async updateCartItemQuantity(itemId: string, quantity: number) {
		const response = await httpClient.patch<CartItem>(
			`${QueryKey.carts}/items/${itemId}`,
			{ quantity }
		);
		return response.data;
	}

	async removeFromCart(itemId: string) {
		const response = await httpClient.delete<CartItem>(
			`${QueryKey.carts}/items/${itemId}`
		);
		return response.data;
	}

	async update(cart: Partial<Cart>) {
		const response = await httpClient.patch<Cart>(QueryKey.carts, cart);
		return response.data;
	}

	async clearCart() {
		const response = await httpClient.delete<Cart>(QueryKey.carts);
		return response.data;
	}
}

export default new CartApi();
